import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import LandingPage from "./Components/LandingPage/Components/ParentPage";
import CoursesPage from "./Components/CoursesPage/Components/ParentCourses";
import CoursesDetailPage from "./Components/CourseDetails/ParentCourses";
import ThankyouPage from "./Components/ThankyouPage/parent";
import Payment from "./Components/Payment/Parent";
import Login from "./Components/Login/Components/Login";
import Signup from "./Components/Studentsign/Signup";
import StudentDashboard from "./Components/StudentDashboard/StudentDashboard";
import InsSign from "./Components/InstructorSign/InsSign";
import MyPrograms from "./Components/StudentMyPrograms/MyPrograms";
import Ins_Profile_parent from "./Components/InsDashboard/Parent";
import Ins_Program_Parent from "./Components/MyProgram/Parent";
import Ins_Program from "./Components/MyProgram/MyProgram";
import Ins_Program_Create from "./Components/MyProgram/CreateProgram";
import MLTDashboard from "./Components/MyProgram/MLTDashboard";
import PrivateRoute from "./PrivateRoute";
import ParentSchedule from "./Components/Schedule/Parent";
import ProgramSchedule from "./Components/Schedule/ProgramSchedule";
import Insstudent from "./Components/Insstudent/Parent";
import Add_student from "./Components/Insstudent/Add_student";
import Insstudent_profile from "./Components/Insstudent/Insstudent";
import Student_details from "./Components/Insstudent/Student_details";
import StudentPayment from "./Components/Insstudent/Student_payment";
import Ins_Forum from "./Components/InsForum/Forum_Parent";
import Review from "./Components/Insstudent/ReviewRatingPage";
import PasswordLink from "./Components/ForgotPassword/PasswordLink";
import ResetPassword from "./Components/ForgotPassword/ResetPassword";
import CreateScheduleForm from "./Components/Schedule/CreateSchedule";
import ParentExcercise from "./Components/MyProgram/ParentExercise";
import MyCourses from "./Components/StudentMyPrograms/MyCourses"
import NewPrograms from "./Components/StudentMyPrograms/NewPrograms";
import StudentMLT from "./Components/StudentMyPrograms/StudentMLT"
import QuizAttend from "./Components/StudentMyPrograms/QuizAttend";
import HavingTrouble from "./Components/ForgotPassword/HavingTrouble";
import Student_Forum from "./Components/StudentForum/Forum_Parent";
import Parent_accomplishment from "./Components/Accomplishments/Parent";
import Accomplishments from "./Components/Accomplishments/Accomplishment";
import WriteReview from "./Components/Accomplishments/WriteReview";
import CertificatePage from "./Components/Accomplishments/CertificatePage";
import CertificateCard from "./Components/Accomplishments/CertificateCard";
import Student_profileparent from "./Components/StudentProfile/ProfileParent";
import Register from "./Components/InstructorSign/Registration"
import InstitutionReg from "./Components/InstructorSign/InstitutionReg"
import TrainingProviderRegistration from "./Components/InstructorSign/TrainingProviderRegistration"
import IndependentTrainerRegistration from "./Components/InstructorSign/IndependentTrainerRegistration"
import SuperAd_Parent from "./Components/SuperAdmin/Parent"
import SuperAd_UserList from "./Components/SuperAdmin/UserList"
import OrgAd_Parent from "./Components/OrgAdmin/Parent"
import OrgAd_UserList from "./Components/OrgAdmin/UserList"
import AdminDashboard from "./Components/AdminDashboard/Parent";
import AdminPrograms from "./Components/AdminPrograms/Parent";
import AdminStudents from "./Components/AdminStudent/Parent";
import AdminReviewPage from "./Components/AdminStudent/AdminReview";
import AdminSchedule from "./Components/AdminSchedule/Parent";
import AdminProgramSchedule from "./Components/AdminSchedule/ProgramSchedule";
import AdminForum from "./Components/AdminForum/Forum_Parent";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/student_signup" element={<Signup />} />
          <Route path="/ins_signup" element={< InsSign/>} />
          <Route path="/register" element={<Register />} />
          <Route path="/register_institution" element={<InstitutionReg />} />
          <Route path="/register_trainingprovider" element={<TrainingProviderRegistration />} />
          <Route path="/register_independenttrainer" element={<IndependentTrainerRegistration />} />
          <Route path="/instructor-signup" element={<InsSign />} />
          <Route path="/courses" element={<CoursesPage />} />
          <Route path="/courses/:course_id" element={<CoursesDetailPage />} />
          <Route path="/thankyou" element={<ThankyouPage />} />
          <Route path="/passwordlink" element={<PasswordLink />} />
          <Route path="/resetpassword" element={<ResetPassword />} />
          <Route path="/having_trouble" element={<HavingTrouble />} />
          <Route path="/student_profile" element={<Student_profileparent />} />

          {/* Protected Instructor Profile */}
          <Route
            path="/ins_program"
            element={
              <PrivateRoute>
                <Ins_Program_Parent />
              </PrivateRoute>
            }
          >
            <Route index element={<Ins_Program />} />
            <Route path="create_program" element={<Ins_Program_Create />} />
            <Route path="module_track" element={<MLTDashboard />} />
            <Route path="exercise" element={<ParentExcercise />} />
            
          </Route>

          {/* Protected Routes */}
          <Route
            path="/payment"
            element={
              <PrivateRoute>
                <Payment />
              </PrivateRoute>
            }
          />
          <Route
            path="/ins_profile"
            element={
              <PrivateRoute>
                <Ins_Profile_parent />
              </PrivateRoute>
            }
          />
          <Route
            path="/student_dashboard"
            element={
              <PrivateRoute>
                <StudentDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/ins_forum"
            element={
              <PrivateRoute>
                <Ins_Forum />
              </PrivateRoute>
            }
          />
          <Route
            path="/student_forum"
            element={
              <PrivateRoute>
                <Student_Forum />
              </PrivateRoute>
            }
          />
          <Route
            path="/ins_student"
            element={
              <PrivateRoute>
                <Insstudent />
              </PrivateRoute>
            }
          >
            <Route index element={<Insstudent_profile />} />
            <Route path="add_student" element={<Add_student />} />
            <Route path="student_details/:id" element={<Student_details />} />
            <Route path="student_payment" element={<StudentPayment />} />
            <Route path="review" element={<Review />} />
          </Route>

          <Route
            path="/program_schdule"
            element={
              <PrivateRoute>
                <ParentSchedule />
              </PrivateRoute>
            }
          >
            <Route index element={<ProgramSchedule />} />
            <Route path="create_schdule" element={<CreateScheduleForm />} />
          </Route>

          <Route
            path="/myprograms"
            element={
              <PrivateRoute>
                <MyPrograms />
              </PrivateRoute>
            }
          >
            <Route index element={<MyCourses />} />
            <Route path="add-new" element={<NewPrograms />} />
            <Route path="stu_mlt" element={<StudentMLT />} />
            <Route path="quiz_attend" element={<QuizAttend />} />
          </Route>

          <Route
            path="/accomplishment"
            element={
              <PrivateRoute>
                <Parent_accomplishment />
              </PrivateRoute>
            }
            >
              <Route index element={<Accomplishments />} />
              <Route path="write_review" element={<WriteReview />} />
              <Route path="view_certificate" element={<CertificatePage />} />
              
          </Route>
          {/* Fallback Route */}
          <Route path="view_certificate" element={<CertificateCard />} />

          <Route
            path="/user_list"
            element={
              <PrivateRoute>
                <SuperAd_Parent />
              </PrivateRoute>
            }
          >
            <Route index element={<SuperAd_UserList />} />
          </Route>
          <Route
            path="/org_user_list"
            element={
              <PrivateRoute>
                <OrgAd_Parent />
              </PrivateRoute>
            }
          >
            <Route index element={<OrgAd_UserList />} />
          </Route>
          <Route
            path="/admin_program_schedule"
            element={
              <PrivateRoute>
                <AdminSchedule />
              </PrivateRoute>
            }
          >
            <Route index element={<AdminProgramSchedule />} />
          </Route>
          <Route
            path="/admin_profile"
            element={
              <PrivateRoute>
                <AdminDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin_programs"
            element={
              <PrivateRoute>
                <AdminPrograms />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin_students"
            element={
              <PrivateRoute>
                <AdminStudents />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin_review"
            element={
              <PrivateRoute>
                <AdminReviewPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin_forum"
            element={
              <PrivateRoute>
                <AdminForum />
              </PrivateRoute>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
